var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallengeBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 106,
    viewBox: "0 0 328 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2974_5147)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 106,
    rx: 12,
    fill: "url(#paint0_linear_2974_5147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.128 125.366C107.226 133.027 176.555 125.705 189.14 95.4192C204.507 58.4371 177.768 43.6574 168.83 46.4759C159.893 49.2945 157.375 55.2512 160.029 61.4376C162.064 66.1825 174.129 77.7999 208.312 44.4229C244.169 9.41133 294.194 17.9418 333.711 54.4371",
    stroke: "white",
    strokeWidth: 12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2974_5147",
    x1: 240,
    y1: 141.964,
    x2: 81.4013,
    y2: -77.9554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792984,
    stopColor: "#FFD34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE24A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2974_5147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 106,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeBanner);
export default __webpack_public_path__ + "static/media/challenge-banner.75be454c43d91cde9b4e999eefaf9e50.svg";
export { ForwardRef as ReactComponent };